import { render } from "./ExploreTwelve.vue?vue&type=template&id=59cb97ae"
import script from "./ExploreTwelve.vue?vue&type=script&lang=js"
export * from "./ExploreTwelve.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__